import Tabs from './main/Tabs'
import { SettingsProvider } from './contexts/SettingsContext'
import {
  indexedDBinit,
  getByCharacters,
  getByIndex,
  getByEnglish,
} from './database/indexedDB'

import Settings from './main/SettingsPage'
import Phrases from './main/Phrases'
import Games from './main/Games'
import Info from './main/Info'
import Search from './main/Search'
import { useState, useEffect, useContext } from 'react'

let _database = require('./database/_database.json')
export const PHRASE_DATA = _database

function App() {


  //  State
  const [favorites, setFavorites] = useState([])
  const [wordList, setWordList] = useState([])
  const [def, setDef] = useState('')
  const [english, setEnglish] = useState(null)
  const [loading, setLoading] = useState(true)
  const [progBarWidth, setProgBarWidth] = useState('20%')

    //  Error display ref
    const [clipId, setClipId ]= useState('wtf')
    const [percent, setPercent] = useState(0)
    const [errorMsg, setErrorMsg ]= useState('wtf')

  useEffect(() => {
    async function initIndexedDB() {
      fetch(`/get_phrase_errors`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(data => data.json())
        .then(reportedErrorsArray => {
          console.log({ reportedErrorsArray })
          PHRASE_DATA.forEach((clip, i) => {
            if (
              reportedErrorsArray
                .map(phrase => phrase.phraseId)
                .includes(String(clip.phraseId))
            ) {
              PHRASE_DATA[i].flagged = 'true'
            }
          })
          try {
          indexedDBinit(loading, setLoading, setProgBarWidth, setClipId, setPercent, setErrorMsg)            
          } catch (error) {
            setErrorMsg(error.message)
          }

          console.log(PHRASE_DATA)
        })
    }

    initIndexedDB()

    // console.log(getByIndex(14))
    // console.log(getByCharacters('我在学中文'))
    // getByEnglish('We are from France.', setEnglish)

    //  Get Favorites Phrase Data from localStorage
    const storageData = JSON.parse(localStorage.getItem('phraseData')) || {
      favorites: [],
    }
    const favorites = storageData?.favorites || []
    setFavorites(favorites)
    PHRASE_DATA.forEach(clip => {
      //  Add favorites prop to each clip
      clip.favorite = favorites.includes(clip.phraseId)
    })

    async function getAllWords(PHRASE_DATA) {
      const words = await getWords(PHRASE_DATA)
      setWordList([...words])
      console.log({ words })
    }

    //  Get all english words
    const allWords = getAllWords(PHRASE_DATA)

    console.log({ PHRASE_DATA })
    console.log({ allWords })
  }, [])

  useEffect(() => {
    if (english === null)
      console.log('English', `'english' is originally set to null`)
    else
      console.log(
        '%cGet by english',
        'text-decoration: underline;font-weight: 900;font-size: 15px',
        english
      )
  }, [english])

  return (
    <div className="App">
      {loading ? (
        <aside>
          {loading !== true && (
            <h1>
              Loading Data...
              <span
                id="loadingProgressBar"
                style={{
                  inlineSize: progBarWidth + '%',
                }}
              ></span>
            </h1>
          )}
          <span
          > 
            <br />
            <h3 style={{textAlign: 'center'}}>{`${percent}%`}</h3>
            <br />
            {/* <p>{clipId}</p> */}
            <br />
            {/* {errorMsg} */}

          </span>
        </aside>
      ) : (
        <main id="main">
          <SettingsProvider>
            <Tabs />
            <Settings
              favorites={favorites}
              setFavorites={setFavorites}
            />
            <Phrases
              PHRASE_DATA={PHRASE_DATA}
              favorites={favorites}
              setFavorites={setFavorites}
              def={def}
              setDef={setDef}
            />
            <Games PHRASE_DATA={PHRASE_DATA} />
            <Search
              PHRASE_DATA={PHRASE_DATA}
              WORD_LIST={wordList}
            />
            <Info numOfPhrases={PHRASE_DATA.length} />
          </SettingsProvider>
        </main>
      )}
    </div>
  )
}

export default App

async function getWords(phraseData) {
  const words = []
  phraseData.map(clip => {
    const wordArray = clip.eng.split(' ')
    words.push(
      ...wordArray
        .filter(word => {
          let newWord = [...word]
            .filter(letter => {
              return letter.match(/[a-zA-Z]/i)
            })
            .join('')
          return newWord.length > 1
        })
        .map(word => {
          return word.toLowerCase().replace(/[^a-zA-Z']/gi, '')
        })
    )
  })

  const uniqueWords = [...new Set(words)].sort((a, b) => {
    if (a < b) {
      return -1
    }
    if (a > b) {
      return 1
    }
    return 0
  })
  return uniqueWords.filter(word => {
    return true
  })
}
